import './Achievements.css';
import { useEffect } from 'react';

function Achievements({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const achievements = [
    {
      title: "Dean's Lister (4x)",
      desc: "Consistently recognized for highly commendable academic performance and maintaining a GWA that qualified for the Dean's List for four consecutive semesters.",
      org: "FAITH Colleges",
      year: "2023–2025",
      icon: "🏅"
    },
    {
      title: "Merit Award",
      desc: "Recipient of the Merit Award for demonstrated excellence in the STEM curriculum and outstanding participation in class activities.",
      org: "APEC Schools",
      year: "2023",
      icon: "🎖️"
    },
    {
      title: "Champion — Division Press Conference",
      desc: "Won first place in the highly competitive Division Press Conference for Sports Writing out of hundreds of participants across the division.",
      org: "DepEd Lipa Division",
      year: "2016",
      icon: "🏆"
    },
    {
      title: "2nd Place — Regional Press Conference",
      desc: "Represented the division and secured second place at the Regional level for Sports Writing, displaying excellence in journalism under pressure.",
      org: "DepEd CALABARZON",
      year: "2016",
      icon: "🥈"
    },
    {
      title: "With High Honors",
      desc: "Graduated with High Honors in recognition of outstanding academic achievements and consistent dedication to studies.",
      org: "Langka Elementary",
      year: "2012",
      icon: "🥇"
    }
  ];

  return (
    <div className="ach-page">
      {/* ── Header ── */}
      <header className="ach-header">
        <div className="ach-header-inner">
          <button className="ach-back-btn" onClick={onNavigateHome}>
            <span className="ach-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="ach-breadcrumb">
            <span className="ach-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="ach-bc-sep">/</span>
            <span className="ach-bc-current">Achievements</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="ach-hero-strip">
        <div className="ach-strip-inner">
          <p className="ach-strip-label">Excellence & Recognition</p>
          <h1 className="ach-strip-name">Academic Achievements</h1>
          <p className="ach-strip-role">Honors, awards, and milestones throughout my academic journey</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="ach-main">
        <div className="ach-grid">
          {achievements.map((item, idx) => (
            <div className="ach-card" key={idx}>
              <div className="ach-icon-wrapper">
                <span className="ach-icon">{item.icon}</span>
              </div>
              <div className="ach-content">
                <div className="ach-meta">
                  <span className="ach-org">{item.org}</span>
                  <span className="ach-year">{item.year}</span>
                </div>
                <h3 className="ach-title">{item.title}</h3>
                <p className="ach-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* ── Footer ── */}
      <footer className="ach-footer">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="ach-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>
    </div>
  );
}

export default Achievements;
